import type { Option } from '@usealloy/component-library';
import type {
  MatrixModel,
  OutputValueRange,
  ValueRangeConfigOptions,
} from '@usealloy/policy-lib/workflows';

import type { Axis } from '../../../editor/components/NodeEditorDrawer/MatrixModel/AxisHeaderDropdown';

// temporary re-exports to keep the existing Daffy import paths while these types move to policy-lib
export {
  MatrixAxisDataType,
  MatrixAxisOrder,
  MatrixDataType,
} from '@usealloy/policy-lib/workflows';

export { HighRangeOption, LowRangeOption } from '@usealloy/policy-lib/workflows';

export type {
  MatrixDimensions,
} from '@usealloy/policy-lib/workflows';

export enum DimensionsTypeChange {
  'CHANGE_TO_2D',
  'CHANGE_TO_1D',
  'NO_CHANGE',
}

export enum DataTypeChange {
  'CHANGE_TO_STRING',
  'CHANGE_TO_NUMBER',
  'NO_CHANGE',
}

export enum MatrixAxisOperation {
  'ADD',
  'DELETE',
}

export type FormState = {
  name: string;
  dataTypeOption: Option;
  dimensionsOption: Option;
  description: string;
  defineValueRanges?: boolean;
  outputValueRange?: OutputValueRange[];
  outputValueRangeOptions?: ValueRangeConfigOptions;
};

export interface UpdateMatrixSizeProps {
  axis: Axis;
  matrix: MatrixModel['matrix'];
  op: MatrixAxisOperation;
  count?: number;
  row?: number;
}
